import React, { forwardRef } from "react";

const TrashIcon = forwardRef(function TrashIcon(
  { count = 0, onOpen },
  ref
) {
  const label = count > 0 ? `Trash (${count})` : "Trash";
  return (
    <button
      ref={ref}
      type="button"
      className="mac-trash"
      onClick={onOpen}
      aria-label={label}
      title={label}
    >
      <span className="mac-trashGlyph" aria-hidden="true" />
      <span className="mac-iconLabel">Trash</span>
    </button>
  );
});

export default TrashIcon;

